import React, { Component } from 'react'
import moment from 'moment'

import { Div, H5, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { getPlaybookInformation } from 'api/playbooks'

const PB_EVENTS_TO_ENGLISH = {
  'bounced': 'had their playbook bounce from mail provider, ',
  'clicked': 'clicked on a CTA',
  'completed': 'has exited',
  'delivered': 'saw an email was delivered',
  'dismissed': 'closed out',
  'email_captured': 'had their email captured',
  'goals_reached': 'reached a goal',
  'meetings_booked': 'booked a meeting',
  'opened': 'opened an email',
  'sent': 'had a playbook send',
  'submitted': 'submitted a CTA',
  'unsubscibed': 'unsubcribed',
}

class TriggeredEvent extends Component {  
  constructor(props) {
    super(props)

    this.state = {
      eventInformation: null
    }
  }
  componentDidMount() {
    this.determineTriggeredEventType()
  }

  getPlaybookInformation = async (pbId) => {
    try {
      const { data: playbook } = await getPlaybookInformation(pbId)

      this.renderEventInformation(playbook)
    } catch(e) {
      console.warn(e)
    }
  }

  renderEventInformation = (playbook) => {
    const { event } = this.props

    const cleanEvent = event.body.event.replace('_playbook_evt_', '')

    const stringTrim = cleanEvent.replace(' ', '_')

    let validEventKey

    const isValid = Object.keys(PB_EVENTS_TO_ENGLISH).some(eventToTest => {
      if (stringTrim.includes(eventToTest)) {
        validEventKey = eventToTest
        return true
      } else {
        return false
      }
    })
    
    this.setState({
     eventInformation: isValid ? ` ${PB_EVENTS_TO_ENGLISH[validEventKey]} from playbook: ${playbook.name}` : `triggered event: ${event.body.event}`
    })
  }

  determineTriggeredEventType = () => {
    const { event } = this.props

    const deepPlaybookIDRegex = /_(\d*)_/g
    const endPBIDRegex = /(_{0}\d)+/g

    if (event.body.event.includes(`_playbook_evt_`)) {
      const replaceWhitespace = event.body.event.replace(' ', '_').replace('_playbook_evt_', '')
      const deepPbId = deepPlaybookIDRegex.exec(replaceWhitespace)
      const endPbId = endPBIDRegex.exec(replaceWhitespace)

      const playbookID = deepPbId ? deepPbId[0] : endPbId[0]

      this.getPlaybookInformation(playbookID)
    } else {
      this.setState({
        eventInformation:  `triggered the following event: ${event.body.event}`
      })
    }
  }
  render() {
    const { eventInformation } = this.state
    const { event, name } = this.props
    return (
      <Div className="contact-event--container">
        <Div className="contact-event--icon">
          <Icon name="flash-2" width={20} height={20}/>
        </Div>
        <Div className="contact-event--event-description">
          <H5>
            {name} {!!eventInformation && eventInformation }
          </H5>
          <Span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</Span>
        </Div>
      </Div>
    )
  }

}

export default TriggeredEvent
